import { createSelector, createStructuredSelector } from 'reselect';
import { initialState } from './reducer';
import { initialState as AVCstate } from '../AvailabilityCheck/reducer';
import { RootState } from './types';
import { APP_NAMESPACE, AVC_NAMESPACE } from './constants';

const selectState = (state: RootState) => state[APP_NAMESPACE] || initialState;
const selectAVCState = (state: RootState) => state[AVC_NAMESPACE] || AVCstate;

export const selectAppState = createSelector(selectState, state => state);
export const selectLoading = createSelector(selectState, state => state.loading);
export const selectAddress = createSelector(selectState, state => state.address);
export const selectTariff = createSelector(selectState, state => state.selected.tariff);
export const selectTariffs = createSelector(selectState, state => state.tariffs[state.activeProviderType]);
export const selectProviderType = createSelector(selectState, state => state.activeProviderType);
export const selectSelected = createSelector(selectState, state => state.selected);
export const selectGigakombi = createSelector(selectState, state => state.gigakombi);
export const selectFF = createSelector(selectState, state => state.familyAndFriends);
export const selectAvcResult = createSelector(selectState, state => state.avcResult);
export const selectBackendDown = createSelector(selectState, state => Boolean(state.error));
export const selectLoaded = createSelector(selectState, state => state.overlayLoaded);
export const selectIsOverlayOpen = createSelector(selectState, state => state.isOverlayOpen);
export const selectActiveOverlay = createSelector(selectState, state => state.activeOverlay);
export const selectAccessSupplier = createSelector(selectAVCState, state => state.accessSupplier);
export const selectRolloutEndMonth = createSelector(selectAVCState, state => state.rolloutEndMonth);
export const selectRolloutStatus = createSelector(selectAVCState, state => state.rolloutStatus);
export const selectAvailabilityIndicator =
    createSelector(selectAVCState, state => state.availabilityIndicator);
export const selectContentEnabled = createSelector(selectState,
    ({ avcResult, tariffs, activeProviderType: activeProductType }) => {
        if (!avcResult) {
            return true;
        }

        if (!avcResult.availability.fiber) {
            return false;
        }

        const selectedTariffs = tariffs[activeProductType];
        const available = selectedTariffs.filter(t => avcResult.metacodes.includes(t.id));

        return Boolean(available.length);
    }
);
export const selectUserInfo = createSelector(selectState, state => state.userInfo);
export const selectIsAutoOverlayOpen = createSelector(selectState, state => state.isAutoOverlayOpened);
export const selectPreMarketingType = createSelector(selectState, state => state.preMarketing);

export const selectors = createStructuredSelector({
    appState: selectAppState,
    loading: selectLoading,
    address: selectAddress,
    activeProviderType: selectProviderType,
    selected: selectSelected,
    gigakombi: selectGigakombi,
    ff: selectFF,
    avcResult: selectAvcResult,
    backendDown: selectBackendDown,
    selectedTariff: selectTariff,
    tariffs: selectTariffs,
    activeOverlay: selectActiveOverlay,
    overlayLoaded: selectLoaded,
    isOverlayOpen: selectIsOverlayOpen,
    contentEnabled: selectContentEnabled,
    userInfo: selectUserInfo,
    preMarketingType: selectPreMarketingType,
    accessSupplier: selectAccessSupplier,
    availabilityIndicator: selectAvailabilityIndicator,
    rolloutEndMonth: selectRolloutEndMonth,
    rolloutStatus: selectRolloutStatus,
    isAutoOverlayOpened: selectIsAutoOverlayOpen,
});
